;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.radio = (function () {
    const initialize = function () {
      $('.js-radio').on('click', function (e) {
        $(this).parent().toggleClass('is-selected')
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.radio.initialize()
  })
}(jQuery, window))
